<template>
  <div class="step-unit" @click="stepClick">
    <slot></slot>
  </div>
</template>

<script>
export default {
  methods: {
    stepClick: function() {
      this.$emit("step-click")
    }
  },
  data: function() {
    return {};
  }
};
</script>

<style scoped>
</style>